export default "__VITE_ASSET__DFOJCEAU__"